/**
 * Feature flag for the SLA area: the network scan (IBM-1039) — the "Network
 * scan" tab in the installed base node detail panel, the badge on tree rows,
 * the `installedBaseNodeId` jump-off filter in the asset list and the IoT
 * attach gate (`AssetLocation`/`System.canAttachIotConnection`) in the
 * connection wizard and the system registration — and the IoT commissioning
 * (IBM-1045): the SLA status chip in the asset hero, the "Start commissioning"
 * button and the commissioning wizard. Baked in at build time by CRA: true on
 * testing and in local dev (.env.testing / .env.local), false in production
 * and on staging until both backends (installed base and IoT) ship there.
 * With the flag off no query selects the new schema fields, so the build keeps
 * working against a gateway that does not know them. The changelog entries
 * are parked in HTML comments in CHANGELOG.md for the same reason. Kept as a
 * module so tests can mock it.
 */
export const isSlaEnabled = (): boolean =>
    process.env.REACT_APP_ENABLE_SLA === 'true';
